var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAutomatedReminders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sales-Pricing-Tool-Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Multi-Office-Sales-Tool---Select-Locations-No-Errors-Copy-33",
    transform: "translate(-40.000000, -423.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(40.000000, 423.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#28CAF4",
    strokeWidth: 2.4,
    fill: "#FFFFFF",
    x: 4.2,
    y: 30.2,
    width: 29.6,
    height: 7.6,
    rx: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#28CAF4",
    strokeWidth: 2.4,
    fill: "#FFFFFF",
    x: 1.2,
    y: 4.2,
    width: 33.6,
    height: 29.6,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#28CAF4",
    x: 0,
    y: 11,
    width: 36,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#28CAF4",
    strokeWidth: 2.4,
    fill: "#FFFFFF",
    x: 9.2,
    y: 1.2,
    width: 3.6,
    height: 6.6,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    stroke: "#28CAF4",
    strokeWidth: 2.4,
    fill: "#FFFFFF",
    x: 23.2,
    y: 1.2,
    width: 3.6,
    height: 6.6,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    stroke: "#28CAF4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 24.5,
    y: 17,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    stroke: "#28CAF4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 15.5,
    y: 17,
    width: 4,
    height: 4,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    stroke: "#28CAF4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 6.5,
    y: 17,
    width: 4,
    height: 4,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    stroke: "#28CAF4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 24.5,
    y: 25,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    stroke: "#28CAF4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 15.5,
    y: 25,
    width: 4,
    height: 4,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-21",
    stroke: "#28CAF4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 6.5,
    y: 25,
    width: 4,
    height: 4,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#28CAF4",
    strokeWidth: 2.4,
    fill: "#FFFFFF",
    cx: 30,
    cy: 30,
    r: 8.8
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-27",
    stroke: "#28CAF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    points: "30 25 30 31.4 34 33"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAutomatedReminders);
export default __webpack_public_path__ + "static/media/icon-automated-reminders.dda1d4e66bb7c16ba5193c7d3a0d47b5.svg";
export { ForwardRef as ReactComponent };